// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"4905":"AboutEditComponent","7934":"Viewer","8634":"RootWidget","9513":"Toast"}[chunkId] || chunkId) + ".chunk.min.css";
};